import { Results as ReactifySearchResults, Stats, useResults, useSearch } from "@usereactify/search";
import React from "react";
import { Loading } from "../Loading";
import { ResultsError } from "../Results/ResultsError";
import { ShowAll } from "../ResultsMeta/ShowAll";
import { InstantSearchItem } from "./InstantSearchItem";
import { InstantSearchNoResults } from "./InstantSearchNoResults";

export const InstantSearchResults: React.FC = () => {
  const { searchTerm } = useSearch();
  const { resultStats } = useResults();
  return (
    <div className="container flex justify-center">
      <div className="grid results-sec">
        <div className="grid__item medium-up--one-whole">
          <div className="grid">
            <div className="grid__item medium-up--four-fifths">
              {resultStats?.numberOfResults && (
                <h2 className="h4 results-meta">
                  {`Showing ${resultStats?.displayedResults} of ${resultStats?.numberOfResults} results for ‘${searchTerm}’`}
                </h2>
              )}
            </div>
          </div>
          <div className="new-grid product-grid collection-grid instant-search-results" data-view="6-3">
            <ReactifySearchResults
              listClassName={`grid grid-cols-6`}
              pageSize={6}
              renderNoResults={() => <InstantSearchNoResults />}
              renderLoading={() => <Loading />}
              renderError={(props) => <ResultsError {...props} />}
              renderResultCardProduct={(props) => <InstantSearchItem itemRef={props.itemRef} product={props.product} />}
            />
            <Stats
              render={(renderProps) => (
                <div className="grid__item medium-up--one-whole text-center">
                  <ShowAll {...renderProps} />
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
